import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ShowPictureBase64ModalComponent } from '../show-picture-base64-modal/show-picture-base64-modal.component';

@Component({
  selector: 'app-upload-picture-input',
  templateUrl: './upload-picture-input.component.html',
  styleUrls: ['./upload-picture-input.component.scss']
})
export class UploadPictureInputComponent implements OnInit {

  @ViewChild('inputFile') inputFileRef!: ElementRef;
  @ViewChild('inputFileMult') inputFileMultRef!: ElementRef;
  @ViewChild('inputFileGrid') inputFileGridRef!: ElementRef;
  @ViewChild('inputFileMultGrid') inputFileMultGridRef!: ElementRef;

  @Input() label!: string;
  @Input() media!: any;
  @Input() medias!: any[];
  @Input() multiple: boolean = false;
  @Input() maxLength: number = 10;
  @Input() gridArray: any[] | undefined;
  @Output() addFileCalled = new EventEmitter<any>();
  @Output() removeFileCalled = new EventEmitter<any>();

  currentGridElement: any;
  gridMedias: any[] | undefined;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.gridArray) {
      this.initGridMedias();
    }
  }

  initGridMedias() {
    if (this.gridArray) {
      this.gridMedias = [];
      for (const gridElem of this.gridArray) {
        let srcMedia = (this.medias || []).find((med: any) => med.meta?.gridId == gridElem.id);
        let media = {
          id: srcMedia?.id ? srcMedia.id : null,
          gridLabel: gridElem.label,
          gridId: gridElem.id,
          src: srcMedia?.id ? srcMedia.urlWebp : (srcMedia?.base64 ? srcMedia.base64 : null)
        }
        this.gridMedias.push(media);
      }
    }

  }

  async changeListenerDoc(event: any): Promise<void> {
    try {
      let file = event.target.files[0];
      let originData = await this.fileToBase64(file);

      this.media = {
        mimetype: file.type,
        type: 'PHOTO',
        fileName: file.name,
        base64: originData
      };

      this.addFileCalled.emit(this.media);

    } catch (error) {
      console.error(error);
    }
  }

  async changeListenerDocGrid(event: any): Promise<void> {
    try {
      let file = event.target.files[0];

      if (file) {
        if (!this.medias) this.medias = [];

        let originData = await this.fileToBase64(file);

        let media = {
          mimetype: file.type,
          type: 'PHOTO',
          fileName: file.name,
          base64: originData,
          meta: {
            gridId: this.currentGridElement.gridId,
            gridLabel: this.currentGridElement.gridLabel
          }
        };

        this.medias.push(media);
        this.initGridMedias();

        this.addFileCalled.emit(this.medias);

      }

    } catch (error) {
      console.error(error);
    }
  }

  async changeListenerDocMult(event: any): Promise<void> {
    try {
      let files = event.target.files;

      if (files && files.length) {
        if (!this.medias) this.medias = [];
        for (const file of files) {

          if (this.maxLength && this.medias.length == this.maxLength) {
            break;
          }

          let originData = await this.fileToBase64(file);

          let media = {
            mimetype: file.type,
            type: 'PHOTO',
            fileName: file.name,
            base64: originData
          };

          this.medias.push(media)
        }
        this.addFileCalled.emit(this.medias);
      }

    } catch (error) {
      console.error(error);
    }
  }

  async changeListenerDocMultGrid(event: any): Promise<void> {
    try {
      let files = event.target.files;

      if (files && files.length) {
        if (!this.medias) this.medias = [];
        for (const file of files) {

          if (this.maxLength && this.medias.length == this.maxLength) {
            break;
          }

          let originData = await this.fileToBase64(file);

          let media = {
            mimetype: file.type,
            type: 'PHOTO',
            fileName: file.name,
            base64: originData
          };

          this.medias.push(media)
        }
        this.addFileCalled.emit(this.medias);
      }

    } catch (error) {
      console.error(error);
    }
  }

  public async fileToBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async _event => {
        resolve(reader.result);
      }
      reader.onerror = async _event => {
        reject(reader.error);
      }

      reader.readAsDataURL(file);

    });
  }

  addFile() {
    this.inputFileRef.nativeElement.click();
  }

  removeFile(event: any) {
    event.stopPropagation();
    event.preventDefault();

    this.removeFileCalled.emit();
    this.media = null;
  }

  addFileMult() {
    this.inputFileMultRef.nativeElement.click();
  }

  removeFileMult(event: any, index: any) {
    event.stopPropagation();
    event.preventDefault();

    this.medias.splice(index, 1);
    this.removeFileCalled.emit(this.medias);
  }

  addFileGrid(gridElem: any) {
    this.currentGridElement = gridElem;
    this.inputFileGridRef.nativeElement.click();
  }

  removeFileGrid(event: any, gridElem: any) {
    event.stopPropagation();
    event.preventDefault();

    // find media element index
    let mediaIndex = this.medias.findIndex((med: any) => med.meta?.gridId == gridElem.gridId);
    if (mediaIndex !== -1) {
      this.medias.splice(mediaIndex, 1);
      this.removeFileCalled.emit(this.medias);
      this.initGridMedias();
    }


  }

  addFileMultGrid() {
    this.inputFileMultGridRef.nativeElement.click();
  }

  removeFileMultGrid(event: any, index: any) {
    // event.stopPropagation();
    // event.preventDefault();

    // this.medias.splice(index,1);
    // this.removeFileCalled.emit(this.medias);
  }

  openMedia(media: any) {
    if (media.id) {
      window.open('/api/' + media.url);
    } else {
      this.showModalBase64(media.base64);
    }
  }

  openMediaGrid(gdMedia:any){
    if (gdMedia.id) {
      window.open('/api/' + gdMedia.src);
    } else {
      this.showModalBase64(gdMedia.src);
    }
  }

  async showModalBase64(base64: any) {
    const options: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,

    }
    let modalShowBase64 = await this.modalService.open(ShowPictureBase64ModalComponent, options);
    modalShowBase64.componentInstance.base64 = base64;

    modalShowBase64.result;

  }


}
